import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ArmyBuilderConfig } from '../global/config';
import { HttpClientWithInFlightCache } from '../global/httpClient';
import { EventOrganiserApplication } from './models';

@Injectable({ providedIn: 'root' })
export class OrganiserApplicationService {
    private config = inject(ArmyBuilderConfig);
    private http = inject(HttpClientWithInFlightCache);

    private get baseUrl() {
        return `${this.config.apiBaseUrl}/event-organiser-applications`;
    }

    apply(data: { contactName: string; contactEmail: string; wantsPaidEvents: boolean }): Observable<EventOrganiserApplication> {
        return this.http.post(`${this.baseUrl}`, data, { requiresLogin: true });
    }

    getMine(): Observable<EventOrganiserApplication | null> {
        return this.http.get(`${this.baseUrl}/mine`, { requiresLogin: true });
    }

    listPending(): Observable<EventOrganiserApplication[]> {
        return this.http.get(`${this.baseUrl}/pending`, { requiresLogin: true });
    }

    approve(id: string, reviewNotes?: string): Observable<EventOrganiserApplication> {
        return this.http.put(`${this.baseUrl}/${id}/approve`, { reviewNotes }, { requiresLogin: true });
    }

    reject(id: string, reviewNotes: string): Observable<EventOrganiserApplication> {
        return this.http.put(`${this.baseUrl}/${id}/reject`, { reviewNotes }, { requiresLogin: true });
    }
}
